"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.confirmModal = exports.updateAppActions = exports.showAppMessage = exports.hideAppSpinner = exports.showAppSpinner = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var AppActions = {};

var showAppSpinner = function showAppSpinner() {
  AppActions.setLoading(true);
};

exports.showAppSpinner = showAppSpinner;

var hideAppSpinner = function hideAppSpinner() {
  AppActions.setLoading(false);
};

exports.hideAppSpinner = hideAppSpinner;

var showAppMessage = function showAppMessage(params) {
  AppActions.setMessageParams(params);
  AppActions.setIsMessageVisible(true);
};

exports.showAppMessage = showAppMessage;

var updateAppActions = function updateAppActions(actions) {
  AppActions = _objectSpread({}, AppActions, {}, actions);
};

exports.updateAppActions = updateAppActions;

var confirmModal = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve) {
              AppActions.setConfirmModalParams(_objectSpread({}, params, {
                onConfirm: function onConfirm() {
                  AppActions.setIsConfirmModalVisible(false);
                  return resolve(true);
                },
                onCancel: function onCancel() {
                  AppActions.setIsConfirmModalVisible(false);
                  return resolve(false);
                }
              }));
              AppActions.setIsConfirmModalVisible(true);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function confirmModal(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.confirmModal = confirmModal;